<template>
  <div :class="$style.wrapper">
    <div :class="$style.contentWrapper">
      <div :class="$style.logo">
        <a href="https://www.planet7casino.com/">
          <b-img src="https://www.p7campaign.com/images/planet7.svg" fluid-grow />
        </a>
      </div>
      <div :class="$style.wheelWrapper">
        <TheWinWheel
          @on-win="handleWin"
        />
        <Modal
          v-if="winType"
          :win-type="winType"
          :coupon="getModalCouponCode()"
          url="https://www.planet7casino.com/signup?coupon="
          @close="winType = null"
        />
      </div>
      <div :class="$style.footerWrapper">
        <span>SPIN THE WHEEL FOR AN</span>
        <strong>INTERSTELLAR BONUS!</strong>
      </div>
    </div>
  </div>
</template>

<script>
import TheWinWheel from '@/components/TheWinWheel.vue'
import Modal from '@/components/Modal.vue'

export default {
  name: 'Main',
  components: {
    Modal,
    TheWinWheel
  },
  data () {
    return {
      winType: false,
      config: window.modals,
      titleType: false
    }
  },
  methods: {
    handleWin (winType) {
      this.winType = winType
    },
    getModalCouponCode () {
      return this.config[`modal-${this.winType}`].coupon
    }
  }
}
</script>

<style lang="scss" module>
    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background: #910000;
      padding: 15px;
      height: 59px;
      z-index: 3;
      img {
        width: 100%;
        max-width: 200px;
        max-height: 36px;
      }
    }
  .wrapper {
    background: #341a48 no-repeat center;
    background-size: cover;
    background-image: url('../assets/wheel-of-fotrune-bg.jpg'),
      url('../assets/wheel-of-fotrune-bg-sm.jpg');
    overflow-x: hidden;
    height: 100%;
    width: 100%;

    .contentWrapper {
      min-height: 90%;
      display: flex;
      align-items: center;
      flex-direction: column;
      &:after{
        background-position: bottom center;
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-image: url('../assets/characters-mob.png');
        content: '';
        position: fixed;
        width: 100%;
        height: 90vh;
        bottom: 0;
        left: 0;
      }
      @media (min-width: 576px) {
      &:after {
        background-position: bottom center;
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-image: url('../assets/characters.png');
        content: '';
        position: fixed;
        width: 100%;
        height: 90vh;
        bottom: 0;
        left: 0;
      }
    }
      .wheelWrapper {
        padding: 20px 0 40px 0;
        display: flex;
        flex: 1 1 auto;
        align-items: center;
        @media (max-width:768px) {
          margin: 20px 0;
        }
        @media (max-width:576px) {
          padding: 60px 0 40px 0;
          margin: 20px;
        }
      }
      .footerWrapper{
        display: flex;
        flex-direction: column;
        color: #fff;
        gap: 5px;
        font-size: 27px;
        font-weight: 400;
        text-align: center;
        padding: 0 !important;
        margin: 20px auto 20px auto;
        line-height: 27px;
        z-index: 1;
        @media (max-width:992px) {
          margin: 30px auto 20px auto;
        }
        @media (max-width:576px) {
          max-width: 230px;
          font-size: 16px;
        }
      }
    }
  }
</style>
